var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        __publicField(this, "abortController");
        __publicField(this, "onVariantChangeUnsubscriber");
        __publicField(this, "pendingRequestUrl", null);
        __publicField(this, "preProcessHtmlCallbacks", []);
        __publicField(this, "postProcessHtmlCallbacks", []);
      }
      get variantSelectors() {
        return this.querySelector("variant-selects");
      }
      get productId() {
        return this.getAttribute("data-product-id");
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }
      get quantityInput() {
        return this.querySelector("quantity-input input");
      }
      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.initQuantityHandlers();
        this.initQuickBuyHandler();
        this.initVariantInputSync();
        this.currentVariant = this.getSelectedVariant(this);
        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
        }
      }
      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
      }
      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          var _a, _b, _c;
          (_b = (_a = window == null ? void 0 : window.Shopify) == null ? void 0 : _a.PaymentButton) == null ? void 0 : _b.init();
          (_c = window == null ? void 0 : window.ProductModel) == null ? void 0 : _c.loadShopifyXR();
        });
      }
      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        this.syncVariantInputFromSelection();
        this.resetProductFormState();
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === "true" && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || "main-product";
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode) : this.handleUpdateProductInfo(productUrl, viewMode)
        });
      }
      get productForm() {
        return this.querySelector('form[is="product-form"');
      }
      resetProductFormState() {
        const productForm = this.productForm;
        productForm == null ? void 0 : productForm.resetFormState();
      }
      handleSwapProduct(productUrl, updateFullPage, viewMode) {
        return (html) => {
          const quickView = html.querySelector("#MainProduct-quick-view__content");
          if (quickView && viewMode === "quick-view") {
            html = quickView.content.cloneNode(true);
          }
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateVariantInputs(variant == null ? void 0 : variant.id);
          this.updateURL(productUrl, variant == null ? void 0 : variant.id);
          if (updateFullPage) {
            document.querySelector("head title").innerHTML = html.querySelector("head title").innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById("shopify-section-sticky-atc-bar"),
              html.getElementById("shopify-section-sticky-atc-bar"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
          this.currentVariant = variant;
        };
      }
      handleUpdateProductInfo(productUrl, viewMode) {
        return (html) => {
          var _a, _b, _c;
          const quickView = html.querySelector("#MainProduct-quick-view__content");
          if (quickView && viewMode === "quick-view") {
            html = quickView.content.cloneNode(true);
          }
          const variant = this.getSelectedVariant(html);
          this.currentVariant = variant;
          (_a = this.pickupAvailability) == null ? void 0 : _a.update(variant);
          this.updateVariantInputs(variant == null ? void 0 : variant.id);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant == null ? void 0 : variant.id);
          this.updateShareUrl(variant == null ? void 0 : variant.id);
          if (!variant) {
            this.setUnavailable();
            return;
          }
          this.updateMedia(variant);
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };
          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) => classList.contains("hidden"));
          updateSourceFromDestination("Barcode", ({ classList }) => classList.contains("hidden"));
          updateSourceFromDestination("Inventory", ({ innerText }) => innerText === "");
          updateSourceFromDestination("Badges", ({ classList }) => classList.contains("hidden"));
          updateSourceFromDestination("PricePerItem", ({ classList }) => classList.contains("hidden"));
          updateSourceFromDestination("Volume");
          this.updateQuantityRules(this.sectionId, this.productId, html);
          (_b = this.querySelector(`#QuantityRules-${this.dataset.section}`)) == null ? void 0 : _b.classList.remove("hidden");
          (_c = this.querySelector(`#VolumeNote-${this.dataset.section}`)) == null ? void 0 : _c.classList.remove("hidden");
          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );
          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
            FoxTheme.variantStrings.soldOut
          );
          document.dispatchEvent(
            new CustomEvent("variant:changed", {
              detail: {
                variant: this.currentVariant
              }
            })
          );
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant
            }
          });
        };
      }
      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];
        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }
        return `${url}?${params.join("&")}`;
      }
      getSelectedVariant(productInfoNode) {
        var _a;
        const variantScript = productInfoNode.querySelector("variant-selects [data-selected-variant]") || productInfoNode.querySelector("script[data-selected-variant]");
        const raw = (_a = variantScript == null ? void 0 : variantScript.textContent) == null ? void 0 : _a.trim();
        if (!raw) return null;
        try {
          return JSON.parse(raw);
        } catch (e) {
          return null;
        }
      }
      getVariantData() {
        if (this._variantData) return this._variantData;
        const variantScript = this.querySelector("variant-selects [data-product-variants]") || this.querySelector("[data-product-variants]");
        if (!variantScript) {
          this._variantData = [];
          return this._variantData;
        }
        try {
          this._variantData = JSON.parse(variantScript.textContent);
        } catch (e) {
          this._variantData = [];
        }
        return this._variantData;
      }
      getSelectedOptionsFromDom() {
        const variantSelects = this.variantSelectors;
        if (!variantSelects) return [];
        return Array.from(variantSelects.querySelectorAll("select, fieldset")).map((element) => {
          if (element.tagName === "SELECT") {
            return element.value;
          }
          const checked = element.querySelector("input:checked");
          return checked ? checked.value : null;
        }).filter((value) => value != null);
      }
      findVariantBySelectedOptions() {
        const selectedOptions = this.getSelectedOptionsFromDom();
        if (!selectedOptions.length) return null;
        return this.getVariantData().find(
          (variant) => variant.options.length === selectedOptions.length && variant.options.every((option, index) => option === selectedOptions[index])
        ) || null;
      }
      syncVariantInputFromSelection() {
        const variant = this.findVariantBySelectedOptions();
        if (!variant) return;
        this.currentVariant = variant;
        this.updateVariantInputs(variant.id);
      }
      initVariantInputSync() {
        const productForm = this.productForm;
        if (!productForm || productForm.dataset.kualaVariantSyncBound === "true") return;
        productForm.dataset.kualaVariantSyncBound = "true";
        productForm.addEventListener(
          "submit",
          () => {
            this.syncVariantInputFromSelection();
          },
          true
        );
      }
      renderProductInfo({ requestUrl, targetId, callback }) {
        var _a;
        (_a = this.abortController) == null ? void 0 : _a.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal }).then((response) => response.text()).then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(responseText, "text/html");
          callback(html);
        }).then(() => {
          var _a2;
          (_a2 = document.querySelector(`#${targetId}`)) == null ? void 0 : _a2.focus();
        }).catch((error) => {
          if (error.name === "AbortError") {
            console.log("Fetch aborted by user");
          } else {
            console.error(error);
          }
        });
      }
      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }
      updateURL(url, variantId) {
        if (this.dataset.updateUrl === "false") return;
        try {
          window.history.replaceState({}, "", `${url}${variantId ? `?variant=${variantId}` : ""}`);
        } catch (error) {
          console.warn("Product URL update failed:", error);
        }
      }
      updateVariantInputs(variantId) {
        const nextValue = variantId != null ? String(variantId) : "";
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (!input) return;
          input.value = nextValue;
          input.setAttribute("value", nextValue);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
      updateMedia(variant) {
        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return;
        const setActiveMedia = () => {
          if (typeof productMedia.setActiveMedia === "function") {
            productMedia.init();
            productMedia.setActiveMedia(variant);
            return true;
          }
          return false;
        };
        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }
      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
      }
      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;
        const getAddToCartText = () => {
          if (this.currentVariant && typeof window.kualaPickAtcLabel === "function") {
            return window.kualaPickAtcLabel(this.currentVariant.id, this.dataset.section);
          }
          return FoxTheme.variantStrings.addToCart;
        };
        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = getAddToCartText();
        }
        const quickBuyBtn = productForm.querySelector(".product-form__quick-buy-btn");
        if (quickBuyBtn) quickBuyBtn.toggleAttribute("disabled", disable);
        if (!modifyClass) return;
      }
      setUnavailable() {
        this.toggleAddButton(true, FoxTheme.variantStrings.unavailable);
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        if (price) price.classList.add("hidden");
        if (inventory) inventory.classList.add("hidden");
        if (sku) sku.classList.add("hidden");
      }
      initQuickBuyHandler() {
        this.addEventListener("click", (e) => {
          const quickBuyBtn = e.target.closest(".product-form__quick-buy-btn");
          if (!quickBuyBtn || quickBuyBtn.disabled) return;
          const productForm = this.productForm;
          if (!productForm) return;
          e.preventDefault();
          quickBuyBtn.classList.add("btn--loading");
          quickBuyBtn.setAttribute("aria-disabled", "true");
          const formData = new FormData(productForm);
          const config = FoxTheme.utils.fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];
          config.body = formData;
          fetch(FoxTheme.routes.cart_add_url, config).then((response) => response.json()).then((parsedState) => {
            if (parsedState.status) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: parsedState.errors || parsedState.description,
                message: parsedState.message
              });
              const formErrorMessage = productForm.querySelector(".product-form__error-message");
              if (formErrorMessage) {
                formErrorMessage.hidden = false;
                formErrorMessage.textContent = parsedState.description || FoxTheme.cartStrings.error;
              }
              return;
            }
            window.location.href = FoxTheme.routes.checkout_url || "/checkout";
          }).catch((error) => {
            console.error(error);
            const formErrorMessage = productForm.querySelector(".product-form__error-message");
            if (formErrorMessage) {
              formErrorMessage.hidden = false;
              formErrorMessage.textContent = FoxTheme.cartStrings.error;
            }
          }).finally(() => {
            quickBuyBtn.classList.remove("btn--loading");
            quickBuyBtn.removeAttribute("aria-disabled");
          });
        });
      }
      initQuantityHandlers() {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();
        if (!this.hasAttribute("data-original-section")) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }
      setQuantityBoundries() {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId
          }
        });
      }
      fetchQuantityRules() {
        var _a, _b, _c;
        const currentVariantId = (_b = (_a = this.productForm) == null ? void 0 : _a.productIdInput) == null ? void 0 : _b.value;
        if (!currentVariantId) return;
        (_c = this.querySelector(".quantity__rules-cart")) == null ? void 0 : _c.classList.add("btn--loading");
        fetch(`${this.getAttribute("data-url")}?variant=${currentVariantId}&section_id=${this.sectionId}`).then((response) => response.text()).then((responseText) => {
          const parsedHTML = new DOMParser().parseFromString(responseText, "text/html");
          this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
        }).catch((error) => {
          console.error(error);
        }).finally(() => {
          var _a2;
          (_a2 = this.querySelector(".quantity__rules-cart")) == null ? void 0 : _a2.classList.remove("btn--loading");
        });
      }
      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML
          }
        });
        this.setQuantityBoundries();
      }
    }
  );
}
if (!customElements.get("product-promotion-alert")) {
  customElements.define(
    "product-promotion-alert",
    class ProductPromotionAlert extends HTMLElement {
      constructor() {
        super();
        this.abortController = new AbortController();
        this.buttonEl = this.querySelector("button");
        this.buttonEl.addEventListener("click", this.onClick.bind(this), {
          signal: this.abortController.signal
        });
      }
      onClick(evt) {
        evt.preventDefault();
        this.closest(".product__block").classList.add("hidden");
      }
      disconnectedCallback() {
        this.abortController.abort();
      }
    }
  );
}
